export const costTypes = {
  COST: 'cost',
  FREE: 'free',
  CUSTOM_TEXT: 'custom_text'
};

export default costTypes;
